'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ICON_TYPES = exports.ICON_TYPES = {
    STRING: 'string',
    SVG: 'svg'
};

var STRING_ICON_MAX_LENGTH = exports.STRING_ICON_MAX_LENGTH = 4;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/elementIcon/elementIconConstants.js
// module id = 429
// module chunks = 0